import React, { useState, useEffect } from 'react';

// Particle/confetti component for celebrations
const StreakCelebration = ({ milestone, onComplete }) => {
  const [particles, setParticles] = useState([]);

  useEffect(() => {
    const colors = milestone >= 100
      ? ['#ffd700', '#ff6b6b', '#4ecdc4', '#a855f7', '#f472b6']
      : milestone >= 50
        ? ['#22c55e', '#3b82f6', '#fbbf24', '#a855f7']
        : ['#22c55e', '#3b82f6', '#fbbf24'];

    const particleCount = milestone >= 100 ? 60 : milestone >= 50 ? 40 : 25;

    const newParticles = Array.from({ length: particleCount }, (_, i) => ({
      id: i,
      x: 50 + (Math.random() - 0.5) * 20,
      y: 50,
      vx: (Math.random() - 0.5) * 15,
      vy: -Math.random() * 12 - 5,
      color: colors[Math.floor(Math.random() * colors.length)],
      size: Math.random() * 8 + 4,
      rotation: Math.random() * 360,
      rotationSpeed: (Math.random() - 0.5) * 20,
    }));

    setParticles(newParticles);

    const timer = setTimeout(() => {
      onComplete();
    }, 2000);

    return () => clearTimeout(timer);
  }, [milestone, onComplete]);

  return (
    <div style={{
      position: 'fixed',
      inset: 0,
      pointerEvents: 'none',
      zIndex: 1000,
      overflow: 'hidden',
    }}>
      {/* Milestone banner */}
      <div style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        animation: 'streakPop 0.5s ease-out forwards',
      }}>
        <div style={{
          background: milestone >= 100
            ? 'linear-gradient(135deg, #ffd700, #ff6b6b)'
            : milestone >= 50
              ? 'linear-gradient(135deg, #a855f7, #3b82f6)'
              : 'linear-gradient(135deg, #22c55e, #3b82f6)',
          padding: '20px 48px',
          borderRadius: '16px',
          boxShadow: '0 20px 60px rgba(0,0,0,0.4)',
          textAlign: 'center',
        }}>
          <div style={{ fontSize: '48px', marginBottom: '4px' }}>
            {milestone >= 100 ? '🏆' : milestone >= 50 ? '🔥' : '⚡'}
          </div>
          <div style={{
            fontSize: '32px',
            fontWeight: 'bold',
            color: 'white',
            textShadow: '2px 2px 4px rgba(0,0,0,0.2)',
          }}>
            {milestone} 连胜!
          </div>
          <div style={{
            fontSize: '14px',
            color: 'rgba(255,255,255,0.9)',
            marginTop: '4px',
          }}>
            {milestone >= 100 ? '传奇成就!' : milestone >= 50 ? '太厉害了!' : '继续加油!'}
          </div>
        </div>
      </div>

      {/* Particles */}
      {particles.map((p) => (
        <div
          key={p.id}
          style={{
            position: 'absolute',
            left: `${p.x}%`,
            top: `${p.y}%`,
            width: p.size,
            height: p.size,
            background: p.color,
            borderRadius: p.size > 6 ? '2px' : '50%',
            animation: `particleFall 1.5s ease-out forwards`,
            transform: `rotate(${p.rotation}deg)`,
            '--vx': p.vx,
            '--vy': p.vy,
            '--rot': p.rotationSpeed,
          }}
        />
      ))}

      <style>{`
        @keyframes streakPop {
          0% { transform: translate(-50%, -50%) scale(0); opacity: 0; }
          50% { transform: translate(-50%, -50%) scale(1.1); }
          100% { transform: translate(-50%, -50%) scale(1); opacity: 1; }
        }
        @keyframes particleFall {
          0% {
            transform: translate(0, 0) rotate(0deg);
            opacity: 1;
          }
          100% {
            transform: translate(calc(var(--vx) * 20px), calc(var(--vy) * -30px + 300px)) rotate(calc(var(--rot) * 20deg));
            opacity: 0;
          }
        }
      `}</style>
    </div>
  );
};

export default StreakCelebration;
